import React from "react";
import { getListerUrlParams } from "../..";

const DESCRIPTIONS = {
  csomag: {
    title: "Csomagajánlatok",
    text: "Válogass kedvezményes e-könyv csomagjaink közül – teljes sorozatok és tematikus ajánlatok kedvező áron!",
  },
  akcio: {
    title: "Akciók",
    text: "Tekintsd meg aktuális e-könyv és hangoskönyv akcióinkat, különleges kedvezményekkel!",
  },
  elojegy: {
    title: "Előjegyezhetők",
    text: "Jegyezz elő hamarosan megjelenő e-könyveket, és vásárold meg őket a megjelenés után 48 órán át kedvezményesen!",
  },
  ujdonsag: {
    title: "Újdonságok",
    text: "Válogass legújabb e-könyveink és hangoskönyveink közül – friss megjelenések egy helyen!",
  },
  ekonyv: {
    title: "E-könyvek",
    text: "Fedezd fel e-könyveinket – klasszikusok és újdonságok széles választéka ePub és mobi formátumban!",
  },
  hangoskonyv: {
    title: "Hangoskönyvek",
    text: "Fedezd fel hangoskönyveinket – hallgass bestsellereket, klasszikusokat és friss megjelenéseket bárhol, bármikor!",
  },
  kategoriak: {
    title: "Kategóriák",
    text: "Böngéssz e-könyv és hangoskönyv kategóriáink között: romantika, krimi, fantasy, sci-fi és még sok más!",
  },
  szerzok: {
    title: "Szerzők",
    text: "Kedvenc íróid e-könyvei és hangoskönyvei egy helyen – fedezd fel a szerzők teljes kínálatát!",
  },
  kiadok: {
    title: "Kiadók",
    text: "Fedezd fel a népszerű kiadók e-könyv és hangoskönyv kínálatát – bestsellerek és új megjelenések egy helyen!",
  },
  sorozatok: {
    title: "Sorozatok",
    text: "Fedezd fel népszerű könyvsorozatainkat e-könyv és hangoskönyv formátumban egy helyen!",
  },
  idegen: {
    title: "Idegen nyelven",
    text: "Idegen nyelvű e-könyvek széles választéka angol, német, francia, spanyol és más nyelveken!",
  },
  ajandek: {
    title: "Ajándékutalvány",
    text: "Lepd meg szeretteidet e-könyv és hangoskönyv ajándékutalvánnyal – tökéletes születésnapra, karácsonyra vagy bármilyen különleges alkalomra!",
  },
  blog: {
    title: "Blog",
    text: "Interjúk, olvasási tippek, könyvajánlók és érdekességek – maradj naprakész az e-könyvek és hangoskönyvek világában!",
  },
  toplista: {
    title: "Heti toplista",
    text: "Fedezd fel a hét legnépszerűbb e-könyveit – a toplistánkon minden héten a legkedveltebb címek várnak!",
  },
};

function resolveKeyFromUrl({ dataType, url } = {}) {
  const params = getListerUrlParams(url);
  const pathname = window.location.pathname;

  const tipus = (params.get("tipus") || "").toLowerCase();
  const bongeszde = (params.get("bongeszde") || "").toLowerCase();
  const marketing = (params.get("marketing") || "").toLowerCase();
  const kategoria = (params.get("kategoria") || "").toLowerCase();
  const nyelv = (params.get("nyelv") || "").toLowerCase();

  const isForeignCategory = (slug) => {
    if (!slug) return false;
    const s = String(slug).toLowerCase();
    return s === "idegen-nyelvu-konyvek" || s === "idegen-nyelvu" || /idegen[\s-]?nyelv/.test(s);
  };

  if (bongeszde && /hamarosan/.test(bongeszde)) return "elojegy";
  if (bongeszde && /ujdonsag/.test(bongeszde)) return "ujdonsag";
  if (bongeszde && /toplista/.test(bongeszde)) return "toplista";


  if (isForeignCategory(kategoria)) return "idegen";

  if (dataType === "author" || params.get("szerzo")) return "szerzok";
  if (dataType === "publisher" || params.get("kiado")) return "kiadok";
  if (dataType === "series" || params.get("sorozat")) return "sorozatok";

  if (tipus === "ajandekutalvany" || tipus === "ajandek") return "ajandek";
  if (tipus === "csomag" || dataType === "type_4") return "csomag";
  if (bongeszde === "akcios" || params.get("akcio")) return "akcio";
  if (tipus === "ekonyv") return "ekonyv";
  if (tipus === "hangoskonyv") return "hangoskonyv";

  if (kategoria) return "kategoriak";

  if (nyelv && nyelv !== "magyar") return "idegen";

  if (dataType === "gift" || marketing === "ajandek") return "ajandek";
  if (dataType === "blog" || pathname.includes("/blog")) return "blog";
  if (dataType === "toplista" || marketing === "toplista") return "toplista";

  return null;
}

export default function PageDescription({ forcedKey, title, text, dataType, url }) {
  const key = forcedKey ?? resolveKeyFromUrl({ dataType, url });
  const content = key ? DESCRIPTIONS[key] : null;

  const finalTitle = title ?? content?.title ?? null;
  const finalText = text ?? content?.text ?? null;

  if (!finalTitle && !finalText) return null;

  return (
    <div className="page-description mb-3" style={{ fontSize: "1rem", lineHeight: 1.5, color: "#666" }}>
      {finalText && <p className="m-0">{finalText}</p>}
    </div>
  );
}
